import { render, staticRenderFns } from "./SettingUser.vue?vue&type=template&id=ebe65990&scoped=true&"
import script from "./SettingUser.vue?vue&type=script&lang=js&"
export * from "./SettingUser.vue?vue&type=script&lang=js&"
import style0 from "./SettingUser.vue?vue&type=style&index=0&id=ebe65990&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe65990",
  null
  
)

export default component.exports